<mat-toolbar color="accent">
  <button id="goToPanelButtonDocumentation" mat-icon-button (click)="goToPanel()">
    <mat-icon class="icon-ic_arrow_back" color="secundary"></mat-icon>
  </button>
  <span>{{ 'request.update' | translate }}</span>
</mat-toolbar>
<mat-card>
  <h2>{{ 'request.header.title' | translate }} {{ numOperation }}</h2>
  <div>
    <span>{{ 'request.update.formats' | translate }}</span>
    <span>{{ 'uploadDocuments.filesAllowed' | translate }}</span>
  </div>
  <div>
    <span>{{ 'request.update.weight.long' | translate }}</span>
  </div>
  <scf-drag-drop-update [numOperation]="numOperation" (saveFiles)="setFilesToUpload($event)"></scf-drag-drop-update>
</mat-card>
<div class="btnSend">
  <button
    id="sendFilesButtonDocumentation"
    mat-flat-button
    color="accent"
    [disabled]="disableBtnUpload"
    (click)="sendUploadFiles()"
  >
    {{ 'request.buttonSend' | translate | uppercase }} <mat-icon class="icon-ic_send"></mat-icon>
  </button>
</div>
